/* eslint-disable array-callback-return */
/* eslint-disable no-alert */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux'

import { ACCESSRIGHT } from '../../constants'

import { getAllowedOperations } from '../../utils/authUtils';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';

const AllowedOperationsContext = createContext(); 

const withAllowedOperationsProvider = (
  WrappedComponent,
  ...resourceTypes
) => props => {
  const { authPolicies } = useAuthorizationContext();
  const [allowedOperations, setAllowedOperations] = useState([]);
  const auth = useSelector(state => state.auth);


  const location = useLocation()

  location.pathname

  const history = useHistory()
  const pathUrl = history.location.pathname
  const userPage = () => {
    if (auth.userRole.length >= 1) {
      let  Operations = [];
      auth.userRole.map((role) => {
      if (role === "M") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "S") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "SA") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "DS") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "LI") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "B") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else if (role === "U") {
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }else{
        Operations = Operations.concat(['create-project',"delete", "upload", "download", "downloadCertificate", "downloadAnnexure", "uploadCertificate", "uploadAnnexure", "submit","submit-2"]);
      }
      //  else {
      //   const validePath = ACCESSRIGHT.filter(menu => menu.rolePLI === role)[0].pageDetails.filter(menu => menu.url === pathUrl);
      //   setAllowedOperations(validePath[0].resourceAccess)
      // }
    })
     const uniqueOperations = Operations.filter((item,index) => Operations.indexOf(item) === index);
      setAllowedOperations(uniqueOperations)
    }

  }
  useEffect(() => {
    userPage();
  }, [auth.userRole]);
  return (
    <AllowedOperationsContext.Provider value={{ allowedOperations }}>
      <WrappedComponent {...props} />
    </AllowedOperationsContext.Provider>
  );
};

withAllowedOperationsProvider.propTypes = {
  authPolicies: PropTypes.array
};

export default withAllowedOperationsProvider;

export const useAllowedOperationsContext = () =>
  useContext(AllowedOperationsContext);
